<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9.49609C6.55228 9.49609 7 9.94381 7 10.4961V13.4961C7 14.0484 6.55228 14.4961 6 14.4961H3C2.44772 14.4961 2 14.0484 2 13.4961V10.4961C2 9.94381 2.44772 9.49609 3 9.49609H6ZM13 9.49609C13.5523 9.49609 14 9.94381 14 10.4961V13.4961C14 14.0484 13.5523 14.4961 13 14.4961H10C9.44772 14.4961 9 14.0484 9 13.4961V10.4961C9 9.94381 9.44772 9.49609 10 9.49609H13ZM6 2.49609C6.55228 2.49609 7 2.94381 7 3.49609V6.49609C7 7.04838 6.55228 7.49609 6 7.49609H3C2.44772 7.49609 2 7.04838 2 6.49609V3.49609C2 2.94381 2.44772 2.49609 3 2.49609H6ZM13 2.49609C13.5523 2.49609 14 2.94381 14 3.49609V6.49609C14 7.04838 13.5523 7.49609 13 7.49609H10C9.44772 7.49609 9 7.04838 9 6.49609V3.49609C9 2.94381 9.44772 2.49609 10 2.49609H13Z"
      fill="#868D9C"
    />
  </svg>
</template>
